exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-result-slideshow{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;bottom:calc(50% - .5em);width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.ebx-result-slideshow .ebx-icon{width:1em}", ""]);
